/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Progress_CompleteInputs */

const en_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed complete!`)
};

const fr_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration terminée !`)
};

const de_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einbettung abgeschlossen!`)
};

const it_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporamento completato!`)
};

const ru_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставка завершена!`)
};

const es_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Inserción completada!`)
};

const zh_cn2_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入完成！`)
};

const ja_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`埋め込み完了！`)
};

const hi_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एम्बेड पूरा हुआ!`)
};

const pt_pt2_audio_embed_export_progress_complete = /** @type {(inputs: Audio_Embed_Export_Progress_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporação concluída!`)
};

/**
* | output |
* | --- |
* | "Embed complete!" |
*
* @param {Audio_Embed_Export_Progress_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_progress_complete = /** @type {((inputs?: Audio_Embed_Export_Progress_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Progress_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_progress_complete(inputs)
	if (locale === "de") return de_audio_embed_export_progress_complete(inputs)
	if (locale === "it") return it_audio_embed_export_progress_complete(inputs)
	if (locale === "ru") return ru_audio_embed_export_progress_complete(inputs)
	if (locale === "es") return es_audio_embed_export_progress_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_progress_complete(inputs)
	if (locale === "ja") return ja_audio_embed_export_progress_complete(inputs)
	if (locale === "hi") return hi_audio_embed_export_progress_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_progress_complete(inputs)
	return en_audio_embed_export_progress_complete(inputs)
});